import { ContentBox } from "@msuite/ui/app-shell";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { IncomingInvoicesDueTile } from "./incoming-invoices-due-tile";
import { IncomingInvoicesKpiTile } from "./incoming-invoices-kpi-tile";
import { IncomingInvoicesListTile } from "./incoming-invoices-list-tile";
import { IncomingInvoicesReceivedTile } from "./incoming-invoices-received-tile";
import { IncomingInvoicesStateTile } from "./incoming-invoices-state-tile";
import { IncomingInvoicesSuppliersTile } from "./incoming-invoices-suppliers-tile";
import { useIncomingInvoiceStatistics } from "@/hooks/use-incoming-invoice-statistics";

export function ControllingDashboard() {
	/** Context */
	const { t } = useTranslation();

	/** Query */
	const { statistics, isLoading } = useIncomingInvoiceStatistics();

	/** Render */
	return (
		<ContentBox>
			<div className="grid grid-cols-1 lg:grid-cols-4 content-start gap-4 flex-1 min-h-0 overflow-y-auto scrollbar-hidden bottom-space">
				<IncomingInvoicesKpiTile
					title={t("incoming_invoices.open")}
					icon={icon("Inbox")}
					kpi={statistics?.kpis.open}
				/>
				<IncomingInvoicesKpiTile
					title={t("incoming_invoices.overdue")}
					icon={icon("CircleAlert")}
					kpi={statistics?.kpis.overdue}
				/>
				<IncomingInvoicesKpiTile
					title={t("incoming_invoices.due_in_7_days")}
					icon={icon("CalendarClock")}
					kpi={statistics?.kpis.dueIn7Days}
				/>
				<IncomingInvoicesKpiTile
					title={t("incoming_invoices.awaiting_approval")}
					icon={icon("Stamp")}
					kpi={statistics?.kpis.awaitingApproval}
				/>
				<IncomingInvoicesDueTile
					className="lg:col-span-3"
					duePerWeek={statistics?.duePerWeek ?? []}
				/>
				<IncomingInvoicesStateTile byState={statistics?.byState ?? []} />
				<IncomingInvoicesListTile
					title={t("incoming_invoices.awaiting_approval")}
					icon={icon("Stamp")}
					invoices={statistics?.awaitingApproval ?? []}
					isLoading={isLoading}
					persistenceKey="incoming-invoices-awaiting-approval-table"
					className="lg:col-span-2"
				/>
				<IncomingInvoicesListTile
					title={t("incoming_invoices.overdue")}
					icon={icon("CircleAlert")}
					invoices={statistics?.overdue ?? []}
					isLoading={isLoading}
					persistenceKey="incoming-invoices-overdue-table"
					className="lg:col-span-2"
				/>
				<IncomingInvoicesReceivedTile
					className="lg:col-span-3"
					receivedPerMonth={statistics?.receivedPerMonth ?? []}
				/>
				<IncomingInvoicesSuppliersTile topSuppliers={statistics?.topSuppliers ?? []} />
			</div>
		</ContentBox>
	);
}
